import { combineReducers } from "redux";
import CurrencyRate from "./CurrencyRate";

export default combineReducers({
  CurrencyRate
})
